var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHome = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "223EEF47-A989-4ABD-8284-A1F6CAE419F0")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-",
    transform: "translate(-20.000000, -86.000000)",
    fill: "#4B4B4A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Menu-/-Banners",
    transform: "translate(20.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7494273,9.77016464 C20.1119747,9.37889589 20.0769652,8.77919784 19.6712589,8.43104798 L10.7330076,0.756397156 C10.3273013,0.408247296 9.67685431,0.415540402 9.27968852,0.772838632 L0.311056523,8.84022962 C-0.0861092664,9.19752785 -0.105602466,9.79645821 0.267897667,10.177427 L0.492754004,10.4072239 C0.865797774,10.7881927 1.46878306,10.8336147 1.83869749,10.5083677 L2.50896366,9.91935344 L2.50896366,18.5426199 C2.50896366,19.0716899 2.94583299,19.5 3.48460155,19.5 L6.9805993,19.5 C7.51936786,19.5 7.95623719,19.0716899 7.95623719,18.5426199 L7.95623719,12.5098136 L12.4154207,12.5098136 L12.4154207,18.5426199 C12.4076625,19.0713061 12.7931584,19.4996162 13.331927,19.4996162 L17.0368084,19.4996162 C17.575577,19.4996162 18.0124463,19.0713061 18.0124463,18.542236 L18.0124463,10.0407773 C18.0124463,10.0407773 18.1975991,10.1999461 18.4259759,10.396924 C18.6539616,10.5935179 19.1328163,10.4358845 19.4953637,10.0442319 L19.7494273,9.77016464 Z",
    id: "Path"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home.d0334301.svg";
export { ForwardRef as ReactComponent };